import FavoriteIcon from "@mui/icons-material/FavoriteBorder";
import { IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MarkedRecipeContext } from "../../../contexts/MarkedRecipesContext";
import { UserContext } from "../../../contexts/UserContext";
import { favoriteButton } from "../../../styles/recipeStyles";

const MarkRecipeIcon = ({ recipeId }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { user } = useContext(UserContext);
  const markedRecipeContext = useContext(MarkedRecipeContext) || {};

  const isAuthenticated = !!user;
  const isMarked = markedRecipeContext?.markedRecipeIds?.includes(recipeId);
  const markRecipe = markedRecipeContext?.markRecipe;

  const handleMarkRecipe = (event) => {
    event.stopPropagation();
    if (isAuthenticated && markRecipe) {
      markRecipe(recipeId);
    }
  };

  const title = isAuthenticated ? (isMarked ? t("removeFromMenuPlan") : t("addToMenuPlan")) : t("tooltips.markRecipe");
  return (
    <Tooltip title={title}>
      <IconButton onClick={isAuthenticated ? handleMarkRecipe : undefined} sx={favoriteButton(theme, isMarked, isAuthenticated)} aria-label={title}>
        <FavoriteIcon />
      </IconButton>
    </Tooltip>
  );
};

export default MarkRecipeIcon;
